import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterOrderErrorType } from '@core/enums/master-order-error-type.enum';
import { MasterOrderPaymentPages } from '@core/enums/master-order-payment-pages.enum';
import { AppInitService } from '@core/services/app-init.service';
import { AppState } from '@core/store';
import {
  selectIsFetchedMasterOrderPayment,
  selectMasterOrderError,
  selectOrderStateLoading,
} from '@core/store/order';
import { MasterOrderError } from '@core/store/order/order-state-models';
import { fetchMasterOrderData } from '@core/store/order/order.actions';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-master-order-payment-search',
  templateUrl: './master-order-payment-search.component.html',
  styleUrls: ['./master-order-payment-search.component.scss'],
})
export class MasterOrderPaymentSearchComponent implements OnInit, OnDestroy {
  @Input() orderNumber: string;
  @Output()
  nextPage: EventEmitter<MasterOrderPaymentPages> = new EventEmitter<MasterOrderPaymentPages>();
  readonly OrderNumber: string = 'orderNumber';
  readonly MaxLength: number = 9;
  readonly MasterOrderErrorType = MasterOrderErrorType;

  loading$: Observable<boolean>;
  fetched$: Observable<boolean>;
  errorMessage$: Observable<MasterOrderError>;
  masterOrderNumberForm: FormGroup;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private store$: Store<AppState>,
    private appInitService: AppInitService,
  ) {}

  ngOnInit(): void {
    this.masterOrderNumberForm = this.fb.group({
      [this.OrderNumber]: [
        this.orderNumber ?? '',
        [Validators.required, Validators.maxLength(this.MaxLength)],
      ],
    });

    this.loading$ = this.store$.select(selectOrderStateLoading);
    this.fetched$ = this.store$.select(selectIsFetchedMasterOrderPayment);
    this.errorMessage$ = this.store$.select(selectMasterOrderError);

    this.subscriptions.add(
      this.fetched$
        .pipe(
          filter((success) => success),
          take(1),
        )
        .subscribe(() => {
          const next = this.appInitService.Settings.ec.masterOrderCollectRiskDataFromInput
            ? MasterOrderPaymentPages.AddressPage
            : MasterOrderPaymentPages.InfoPage;
          this.nextPage.emit(next);
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  submit(): void {
    if (this.masterOrderNumberForm.valid) {
      const orderNumber = this.masterOrderNumberForm.get(this.OrderNumber).value;
      this.store$.dispatch(fetchMasterOrderData({ orderNumber }));
    }
  }
}
